export default {
  stripInputConfig: {
    style: {
      base: {
        fontSize: '16px',
        fontFamily: 'raleway-medium, sans-serif',
        fontWeight: '600',
        color: '#424242',
      },
      invalid: {
        color: '#d32f2f',
      },
    },
  },
};
